import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Barbell } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";
import { extractError } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/feed");
    } catch (err) {
      const msg = extractError(err, "Login failed");
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center p-4 grid-bg">
      <div className="w-full max-w-md fade-in">
        <Link to="/" className="flex items-center gap-2 mb-12 justify-center">
          <div className="w-8 h-8 bg-[#FF3B30] flex items-center justify-center">
            <Barbell size={20} weight="bold" color="#0A0A0A" />
          </div>
          <span className="font-display text-3xl font-black tracking-tight">SPOTTER</span>
        </Link>

        <div className="border border-[#27272A] bg-[#121212] p-8">
          <div className="text-xs uppercase tracking-widest text-[#FF3B30] font-mono mb-2">// Access</div>
          <h1 className="font-display text-4xl font-black uppercase mb-8">Sign in</h1>

          <form onSubmit={onSubmit} className="space-y-6">
            <div>
              <label className="text-xs uppercase tracking-widest text-zinc-500 font-semibold block mb-1">Email</label>
              <input
                data-testid="login-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                className="input-line"
              />
            </div>
            <div>
              <label className="text-xs uppercase tracking-widest text-zinc-500 font-semibold block mb-1">Password</label>
              <input
                data-testid="login-password-input"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="input-line"
              />
            </div>

            {error && (
              <div data-testid="login-error" className="border border-[#FF3B30] bg-[#FF3B30]/10 text-[#FF3B30] text-sm px-3 py-2">
                {error}
              </div>
            )}

            <button
              data-testid="login-submit-button"
              type="submit"
              disabled={loading}
              className="btn-primary w-full"
            >
              {loading ? "Signing in..." : "Sign in"}
            </button>
          </form>

          <div className="mt-8 pt-6 border-t border-[#27272A] text-sm text-zinc-500 text-center">
            No account?{" "}
            <Link to="/register" data-testid="login-to-register-link" className="text-white hover:text-[#FF3B30] font-semibold uppercase tracking-wider text-xs">
              Sign up
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
